(() => {
  function init(root) {
    const api = window.UPUPA_TILAUS;
    const calendar = root.closest('[data-upupa-cal]');
    if (!api || !calendar || root.dataset.ready) return;
    const data = api.mealOfferData();
    if (!data?.variants.length) return;
    root.dataset.ready = 'true';
    const labels = JSON.parse(root.querySelector('[data-meal-labels]').textContent);
    const form = root.querySelector('[data-meal-form]');
    const main = form.querySelector('[data-meal-main]');
    const upgrade = form.querySelector('[data-meal-upgrade]');
    const dessert = form.querySelector('[data-meal-dessert]');
    const coffee = form.querySelector('[data-meal-coffee]');
    const quantity = form.querySelector('[data-meal-quantity]');
    const button = form.querySelector('[data-meal-add]');
    const message = form.querySelector('[data-meal-message]');
    const money = cents => new Intl.NumberFormat(labels.locale, { style: 'currency', currency: labels.currency || 'EUR' }).format(cents / 100);
    let iso = '', busy = false, locked = false;
    const productEntries = group => data.products.filter(p => p.group === group).flatMap(product => product.variants.map(variant => ({ product, variant })));
    const all = data.products.flatMap(product => product.variants.map(variant => ({ product, variant })));
    const find = id => all.find(e => String(e.variant.id) === String(id));
    const available = group => productEntries(group).filter(e => e.variant.available && !api.dateProblem(e.product.handle, iso));
    const name = entry => entry.product.title + (entry.variant.title === 'Default Title' ? '' : ' · ' + entry.variant.title);
    const coffeeName = entry => labels[({'59142992625996':'coffee_black','59142992658764':'coffee_milk','59142992691532':'coffee_oat'})[String(entry.variant.id)]] || entry.variant.title;
    function populate() {
      const oldMain = main.value, oldDessert = dessert.value, oldCoffee = coffee.value;
      main.replaceChildren(new Option(labels.choose, ''));
      available('main').filter(e => data.variants.some(v => v.sku.startsWith('UPUPA-MEAL-' + e.variant.id + '-'))).forEach(e => main.add(new Option(name(e) + ' · ' + money(e.variant.price), String(e.variant.id))));
      main.value = Array.from(main.options).some(o => o.value === oldMain) ? oldMain : '';
      dessert.replaceChildren(new Option(labels.choose, ''));
      available('dessert').forEach(e => dessert.add(new Option(name(e), String(e.variant.id))));
      dessert.value = Array.from(dessert.options).some(o => o.value === oldDessert) ? oldDessert : dessert.options.length === 2 ? dessert.options[1].value : '';
      coffee.replaceChildren(new Option(labels.no_coffee, ''));
      available('coffee').filter(e => e.variant.title.includes('250 ml')).forEach(e => coffee.add(new Option(coffeeName(e), String(e.variant.id))));
      coffee.value = Array.from(coffee.options).some(o => o.value === oldCoffee) ? oldCoffee : '';
      root.querySelector('[data-meal-empty]').hidden = main.options.length > 1;
    }
    function selection() {
      const selectedMain = find(main.value), selectedCoffee = find(coffee.value);
      const selectedSalad = upgrade.value !== 'none' ? available('salad')[0] : null;
      const selectedDessert = upgrade.value === 'complete' ? find(dessert.value) : null;
      const tier = upgrade.value === 'none' ? 'coffee' : upgrade.value;
      const bundled = upgrade.value !== 'none' || !!coffee.value;
      const variant = bundled ? data.variants.find(v => v.sku === `UPUPA-MEAL-${main.value}-${tier}-${coffee.value ? 1 : 0}`) : selectedMain?.variant;
      const expected = (selectedMain?.variant.price || 0) + ({none:0,salad:290,complete:690})[upgrade.value] + (coffee.value ? 170 : 0);
      const entries = [selectedMain, selectedSalad, selectedDessert, selectedCoffee].filter(Boolean);
      const props = { _pvm:iso, [labels.date]:api.propLabel(api.isoToUtc(iso)) };
      if (selectedMain) props[labels.main] = name(selectedMain);
      if (selectedSalad) props[labels.salad] = name(selectedSalad);
      if (selectedDessert) { props[labels.dessert] = name(selectedDessert); props._upupa_meal_dessert = String(selectedDessert.variant.id); }
      if (selectedCoffee) { props['Lehmus kahvi'] = coffeeName(selectedCoffee); props._upupa_coffee_variant = String(selectedCoffee.variant.id); }
      const count = Number(quantity.value);
      const valid = !!selectedMain && (!coffee.value || !!selectedCoffee) && (upgrade.value === 'none' || !!selectedSalad) && (upgrade.value !== 'complete' || !!selectedDessert) && !!variant?.available && variant.price === expected && Number.isSafeInteger(count) && count > 0 && entries.every(e => e.variant.available && !api.dateProblem(e.product.handle,iso)) && (!bundled || !api.mealOfferProblem({variant_id:variant.id, properties:props},iso));
      return { variant, entries, props, count, expected, bundled, valid };
    }
    function update() {
      if (!iso) return;
      const selected = selection();
      form.querySelector('[data-meal-dessert-label]').hidden = upgrade.value !== 'complete';
      dessert.required = upgrade.value === 'complete';
      dessert.disabled = busy || upgrade.value !== 'complete';
      [main,upgrade,coffee,quantity].forEach(el => el.disabled = busy);
      upgrade.querySelector('[value="salad"]').disabled = !available('salad').length;
      upgrade.querySelector('[value="complete"]').disabled = !available('salad').length || !available('dessert').length;
      button.disabled = busy || locked || !selected.valid;
      button.textContent = busy ? labels.adding : labels.add;
      form.querySelector('[data-meal-total]').textContent = main.value ? money(selected.expected * (Number.isSafeInteger(selected.count) && selected.count > 0 ? selected.count : 0)) : '—';
      const info = form.querySelector('[data-meal-info]'); info.replaceChildren();
      selected.entries.forEach(e => {const p = document.createElement('p'), a = document.createElement('a'), details = document.createElement('p');a.href=e.product.url;a.textContent=name(e);p.append(a);details.textContent=e.product.description;info.append(p,details);});
    }
    function render(date) {
      if (!date || date === iso) return;
      iso = date; main.value = ''; dessert.value = '';
      root.querySelector('[data-meal-date]').textContent = api.longLabel(api.isoToUtc(iso));
      populate(); update();
    }
    form.hidden = false;
    form.addEventListener('change', () => { if (!locked) message.textContent = ''; update(); });
    form.addEventListener('input', update);
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || locked) return;
      const selected = selection(), selectedDate = iso;
      if (!selected.valid || !form.reportValidity()) { message.textContent=labels.invalid; return; }
      busy = true; message.textContent = ''; update();
      let posted = false;
      try {
        const checks = selected.entries.map(e => ({url:e.product.url,id:e.variant.id,price:e.variant.price}));
        if (selected.bundled) checks.push({url:data.url,id:selected.variant.id,price:selected.expected});
        const fresh = await Promise.all(checks.map(async c => {const r = await fetch(c.url + '.js',{credentials:'same-origin',cache:'no-store'});if(!r.ok)throw Error('check');return (await r.json()).variants.find(v => String(v.id) === String(c.id));}));
        if (fresh.some((v,i) => !v?.available || v.price !== checks[i].price)) { locked=true; message.textContent=labels.changed; return; }
        if (iso !== selectedDate || !selection().valid) { message.textContent=labels.invalid; return; }
        posted=true;
        const response = await fetch(labels.root.replace(/\/?$/,'/')+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:selected.variant.id,quantity:selected.count,properties:selected.props}]})});
        if (!response.ok) throw Error('cart');
        window.location.href=labels.cart;
      } catch { locked=posted; message.textContent=labels.error; form.querySelector('[data-meal-review]').hidden=false; }
      finally { busy=false; update(); }
    });
    calendar.addEventListener('upupa:daychange',event=>render(event.detail.iso));
    const day=calendar.querySelector('.upupa-day[aria-pressed="true"]');
    render(day ? api.utcToIso(Number(day.dataset.u)) : calendar.querySelector('[data-el="menu"] [data-upupa-iso]')?.value);
    if (new URLSearchParams(location.search).get('meal') === 'complete') root.querySelector('details').open=true;
  }
  function scan(){document.querySelectorAll('[data-make-meal]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
  window.addEventListener('load',scan,{once:true});
  document.addEventListener('upupa:daychange',scan);
  document.addEventListener('shopify:section:load',scan);
})();
